module.exports = __webpack_public_path__ + "img/qrcode.a516a203.png";